import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames';
import { GatewayProvider, GatewayDest } from 'react-gateway';
import DemoMessageRoot from '../../containers/demo-message-root';
import MessageRoot from '../../containers/message-root';
import ModalRoot from '../../containers/modal-root';
import Wix from '../../services/wix-sdk-polyfill';
import { WindowResizeListener } from 'react-window-resize-listener';
import { isEditor } from '../../services/wix-sdk-utils';
import { isInWix } from '../../services/is-in-wix';
import AccessibilityListener from '../accessibility-listener';
import styles from './app.scss';

const MIN_WIDTH = 980;

export class AppDesktop extends Component {
  static propTypes = {
    desktopHeader: PropTypes.node,
    main: PropTypes.node.isRequired,
    children: PropTypes.node,
    menu: PropTypes.node,
  };

  componentDidMount() {
    document.documentElement.classList.add('no-scroll');
  }

  handleResize = windowSize => {
    if (Wix.Utils.getViewMode() !== 'editor') {
      return;
    }
    Wix.resizeComponent({
      width: Math.max(MIN_WIDTH, windowSize.windowWidth),
      height: windowSize.windowHeight,
    });
  };

  renderResizeListener() {
    return isEditor() && <WindowResizeListener onResize={this.handleResize}/>;
  }

  render() {
    const { desktopHeader, menu, main, children } = this.props;
    return (
      <GatewayProvider>
        <div className={classNames(styles.app, 'app-desktop', 'forum-background-color')}>
          {this.renderResizeListener()}
          <AccessibilityListener/>
          <MessageRoot/>
          <DemoMessageRoot/>
          <div id="content-wrapper">
            {desktopHeader && React.cloneElement(desktopHeader, { menu })}
            {React.cloneElement(main, { children })}
          </div>
          <GatewayDest name="footer"/>
          {!isInWix() && <ModalRoot/>}
          <GatewayDest name="floating-action-button"/>
          <GatewayDest name="tooltip"/>
        </div>
      </GatewayProvider>
    );
  }
}

export default AppDesktop;



// WEBPACK FOOTER //
// ./app/components/app/app-desktop.js